/**
=========================================================
* JTT React - v2.2.0
=========================================================

* Product Page: https://www.digittrix.com/product/material-dashboard-react
* Copyright 2023 JTT (https://www.digittrix.com)

Coded by www.digittrix.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// JTT React base styles
import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";

const { grey } = colors;
const { size } = typography;

const breadcrumbs = {
  styleOverrides: {
    li: {
      lineHeight: 0,
    },

    separator: {
      fontSize: size.sm,
      color: grey[600],
    },
  },
};

export default breadcrumbs;
